import { FETCH_CONTACT_OPTIONS, UPDATE_DISPLAY_COMPONENT } from './constants'
import { CREATE_FOOTPRINT } from '../UserEvents/constants'

const initialState = {
  isFetching: false,
  displayComponent: 'list',
  contactoptions: []
}

export default function contactOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTACT_OPTIONS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case CREATE_FOOTPRINT.REQUEST: {
      return {
        ...state,
        displayComponent: 'loading'
      }
    }
    case CREATE_FOOTPRINT.SUCCESS: {
      return {
        ...state,
        displayComponent: 'footprintReveal'
      }
    }
    case FETCH_CONTACT_OPTIONS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        contactoptions: action.contactOptions
      }
    }
    case UPDATE_DISPLAY_COMPONENT: {
      return {
        ...state,
        displayComponent: action.component
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/reducer.js